// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1q4NnW6tXFw6tLtGCKS6qJ","carousel":"_55RNGF34J8YDBZJU5OAi5","row":"_2zuy9xdOMoC3yIZmPDrOKQ","row-content":"r2TaJXDYRj2pBgmcpjrjH"};